import React from 'react';
import { MdLocationOn, MdEmail,MdPhone } from 'react-icons/md';

const ContactSystem = () => {
    return (
        <>
            <div align="center">
                <div align="center" className="contactSystem my-5 ">
                    <MdLocationOn className="contacticon" />
                    <p className="mt-3"> Shyamnagar, Satkhira, Bangladeh,9455</p>
                </div>
                
                <div align="center" className="contactSystem contactSystem-last ">
                    <MdEmail className="contacticon" />
                    <p className="mt-3">md.shozon041@gmail.com</p>
                </div>
                <div align="center" className="contactSystem   contactSystem-last ">
                    <MdPhone className="contacticon" />
                    <p className="mt-3">+8801746483681</p>
                </div>
            </div>
        </>
    );
};

export default ContactSystem;